import * as types from './types';

export const setErrorMessage = errorMessage => ({
  type: types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_ERROR_MESSAGE,
  errorMessage
});

export const setLoading = (isLoading) => ({
    type: types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_LOADING,
    isLoading
});

export const resetState = () => ({
    type: types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_RESET_STATE
});

export const setSearchAssociatesAccountHasBeenLinked = (searchAssociatesAccountHasBeenLinked = true) => ({
    type: types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_SEARCH_ASSOCIATES_ACCOUNT_HAS_BEEN_LINKED,
    searchAssociatesAccountHasBeenLinked
});

export const linkSearchAssociatesAccount = (linkData) => ({
    type: types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_LINK_ACCOUNT,
    linkData
});


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-link-search-associates-account/index.js